const addMouseClickListener = (callBack: (event: any) => void) => {
  document.addEventListener('mousedown', callBack);
  document.addEventListener('touchstart', callBack);
};

const removeMouseClickListener = (callBack: (event: any) => void) => {
  document.removeEventListener('mousedown', callBack);
  document.removeEventListener('touchstart', callBack);
};

export { addMouseClickListener, removeMouseClickListener };
